import { ShieldStar } from "@phosphor-icons/react";
import { t } from "../lib/i18n";

export default function AdminBadge({ size = "sm" }) {
  const cls = size === "sm"
    ? "text-[8px] px-1 py-0.5"
    : "text-[10px] px-1.5 py-0.5";
  return (
    <span
      data-testid="admin-badge"
      className={`inline-flex items-center gap-1 ${cls} uppercase tracking-[0.25em] font-bold border border-[#FF0055] text-[#FF0055] bg-[#FF0055]/10 leading-none`}
      title={t.badgeAdmin}
    >
      <ShieldStar size={9} weight="fill" />
      {t.badgeAdmin}
    </span>
  );
}
